import React from 'react';
import './companyPicker.css';

export default function CompanyPaymentBlock({ payment, user, onPaymentClick }) {
    if (!payment) {
        return null;
    }

    return (
        <div className="company-picker-payment-block">
            <div className="company-picker-payment-row">
                <button
                    type="button"
                    className="company-picker-payment-label"
                    onClick={(e) => {
                        e.stopPropagation();
                        onPaymentClick?.(user);
                    }}
                >
                    К оплате
                </button>
                <div className="company-picker-payment-lines">
                    {payment.billLines.map((line, idx) => (
                        <div
                            key={`${idx}-${line}`}
                            className={`company-picker-payment-line${line === 'Все оплачено' ? ' company-picker-payment-line--paid' : ''}`}
                        >
                            {line}
                        </div>
                    ))}
                </div>
            </div>
            <div className="company-picker-payment-row company-picker-service-row">
                <span
                    className="company-picker-payment-label company-picker-payment-label--ghost"
                    aria-hidden="true"
                >
                    К оплате
                </span>
                <div
                    className={`company-picker-service-status${payment.isSuspended ? ' company-picker-service-status--suspended' : ''}`}
                >
                    {payment.serviceStatus}
                </div>
            </div>
        </div>
    );
}
